import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { ExtractStringArrayKeys } from '../../../../../../react-commons/types/extractKeysOfType';
import { useSystemUserGroupActions } from '../../../../resource/resources/persistables/user/systemUserGroupResource';
import { Form_PropertyFieldArrayReference } from '../reference-text-fields/Form_PropertyFieldArrayReference';

export const Form_SystemUserGroupFieldArray = <T extends object>({
    name,
    form,
    readOnly,
    disabled,
    label,
}: {
    form: UseFormReturn<T>;
    readOnly: boolean;
    disabled?: boolean;
    name: ExtractStringArrayKeys<T, false>;
    label: string;
}) => {
    const systemUserGroupActions = useSystemUserGroupActions();
    const systemUserGroupQuery = systemUserGroupActions.useGetAllResources();

    return (
        <Form_PropertyFieldArrayReference
            control={form.control}
            name={name}
            query={systemUserGroupQuery}
            readOnly={readOnly}
            label={label}
            disabled={disabled}
            idSelector={'id'}
            labelAccessor={'name'}
            propertyValidation={undefined}
            propertyDetails={undefined}
            uniqueSelection={true}
            initialOpen={true}
        />
    );
};
